module.exports = __webpack_public_path__ + "img/icon-plus.44faeaf5.svg";